import { create } from 'zustand';

interface SyncStoreState {
    isHistoricalSyncing: boolean;
    historicalSyncProgress: number;
    startHistoricalSync: () => void;
    setHistoricalSyncProgress: (progress: number) => void;
    finishHistoricalSync: () => void;
    resetHistoricalSync: () => void;
}

export const useSyncStore = create<SyncStoreState>((set) => ({
    isHistoricalSyncing: false,
    historicalSyncProgress: 0,
    startHistoricalSync: () => set({ isHistoricalSyncing: true, historicalSyncProgress: 0 }),
    setHistoricalSyncProgress: (progress) =>
        set({ historicalSyncProgress: Math.max(0, Math.min(12, progress)) }),
    finishHistoricalSync: () => set({ isHistoricalSyncing: false, historicalSyncProgress: 12 }),
    resetHistoricalSync: () => set({ isHistoricalSyncing: false, historicalSyncProgress: 0 }),
}));

